export const audioPlayer = () => {
    let isPaused = true;
    const audioPlayer = document.getElementById('audio_player');
    const playPause = document.querySelector('.js-audio-controls');
    let currentTrackNumber = 1;
    
    if ( audioPlayer && playPause ) {
        const numberOfTracks = parseInt(audioPlayer.getAttribute('data-track-count'));
        
        // Toggle the play/pause icons
        playPause.addEventListener('click', (e) => {
            e.preventDefault();

            if ( isPaused ) {
                audioPlayer.play();
            } else {
                audioPlayer.pause();
            }
            
            playPause.classList.toggle('paused');
            isPaused = !isPaused;
        });

        // Play the next track in the playlist when the current track ends
        audioPlayer.addEventListener('ended', () => {
            currentTrackNumber++;

            const nextTrackNumber = currentTrackNumber > numberOfTracks ? 1 : currentTrackNumber;
            const nextTrack = audioPlayer.querySelector('.js-track-playlist-item[data-track-number="'+nextTrackNumber+'"]');
            const nextTrackSrc = nextTrack.getAttribute('src');
            const nextTrackName = 'Now Playing: ' + nextTrack.getAttribute('data-track-name');

            // Update the audio player source
            audioPlayer.setAttribute('src', nextTrackSrc);

            // Play the new track
            audioPlayer.play();
            playPause.classList.remove('paused');
            isPaused = false;

            // Update Track Name
            document.querySelector('.js-track-name').innerHTML = nextTrackName;
        });
    }
};